package com.iptvplayer.web.ui.screen

import androidx.compose.runtime.*
import com.iptvplayer.shared.presentation.viewmodel.FavoritesViewModel
import com.iptvplayer.web.ui.*
import org.jetbrains.compose.web.css.*
import org.jetbrains.compose.web.dom.*

@Composable
fun FavoritesScreen(vm: FavoritesViewModel, onPlay: OnPlay) {
    val state by vm.state.collectAsState()

    PageContainer {
        H2(attrs = { style { property("margin", "0 0 16px") } }) { Text("Favorites") }
        if (state.isLoading && state.favorites.isEmpty()) {
            Spinner()
        } else if (state.favorites.isEmpty()) {
            EmptyState("No favorites yet. Tap ☆ Favorite while watching.")
        } else {
            state.favorites.forEach { f ->
                RowItem(
                    name = f.contentName,
                    imageUrl = f.contentLogoUrl,
                    subtitle = f.contentType.name.lowercase().replaceFirstChar { it.uppercase() },
                    onClick = { onPlay(f.contentId, f.contentName, f.streamUrl, f.contentType, f.contentLogoUrl) },
                ) {
                    GhostButton("Remove") { vm.removeFavorite(f.contentId) }
                }
            }
        }
    }
}
